import { render, staticRenderFns } from "./PermissionHistoryDetail.vue?vue&type=template&id=cfae4afe&scoped=true&"
import script from "./PermissionHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./PermissionHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./PermissionHistoryDetail.vue?vue&type=style&index=0&id=cfae4afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfae4afe",
  null
  
)

export default component.exports